/**
 * Composable to handle Algolia loading state and dealer content fetching
 * Used across search, category, and spares pages
 */
export const useAlgoliaLoading = () => {
  const { dealerContent, fetchDealerContent, getAlgoliaExclusionFilters } = useDealerContent();
  const dealerContentLoaded = ref(false);
  const shouldInitializeAlgolia = ref(false);

  /**
   * Initialize dealer content and set loading state
   */
  const initializeAlgolia = async () => {
    await fetchDealerContent();
    dealerContentLoaded.value = true;
    shouldInitializeAlgolia.value = true;
  };

  /**
   * Get Algolia exclusion filters based on dealer content
   * @param baseFilter Optional base filter to combine with dealer content exclusions
   * @returns Combined filter string for Algolia
   */
  const getFilters = (baseFilter: string = '') => {
    // Get exclusion filters from the dealer content
    const accessControlFiltersCombined = dealerContent.value ? getAlgoliaExclusionFilters() : '';
    const accessControlAddition = accessControlFiltersCombined.length > 0 ? ` AND ${accessControlFiltersCombined}` : '';

    if (baseFilter) {
      return `${baseFilter}${accessControlAddition}`;
    }

    return accessControlFiltersCombined;
  };

  return {
    dealerContent: computed(() => dealerContent.value),
    dealerContentLoaded: computed(() => dealerContentLoaded.value),
    shouldInitializeAlgolia: computed(() => shouldInitializeAlgolia.value),
    initializeAlgolia,
    getFilters
  };
};
